import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './index.css';
import App from './App';
import Import from './components/Import';
import Video from './components/Video';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
  // <App />
  // </React.StrictMode>
  <BrowserRouter basename='/'>
    <Routes>
      <Route path="/" exact element={<App />} />
      <Route path="/import" element={<Import />} />
      <Route path="/stream" element={<Video link={""}/>} />
    </Routes>
  </BrowserRouter>
);